import React, { useRef, useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import "./contactUs.css";
import mailIcon from "../../assests/email-icon.svg";
import phoneIcon from "../../assests/phne-icon.svg";
import emailjs from "emailjs-com";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import FloatingAlert from "../../components/FlotingAlert/FlotingAlert";

const ContactUs = () => {
  const formRef = useRef<HTMLFormElement | null>(null);
  const [isSending, setIsSending] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    subject: "",
  });

  const [errors, setErrors] = useState<{ [key: string]: string }>({});

  // Floating alert state
  const [floatingAlert, setFloatingAlert] = useState<{
    message: string;
    submessage:string;
    type: "success" | "error";
  } | null>(null);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    const newValue = value.replace(/^\s+/, ""); // prevent leading spaces
    setFormData({ ...formData, [name]: newValue });
    setErrors({ ...errors, [name]: "" });
  };

  const validateForm = () => {
    const newErrors: { [key: string]: string } = {};

    if (!formData.name.trim()) newErrors.name = "Full Name is required";

    if (!formData.email.trim()) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+$/.test(formData.email)) {
      newErrors.email = "Enter a valid email address";
    }

    if (!formData.mobile.trim()) {
      newErrors.mobile = "Mobile number is required";
    } else {
      const phoneNumber = parsePhoneNumberFromString(formData.mobile);
      if (!phoneNumber || !phoneNumber.isValid()) {
        newErrors.mobile = "Enter a valid phone number with country code";
      }
    }

    if (!formData.subject.trim()) newErrors.subject = "Subject is required";

    return newErrors;
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const validationErrors = validateForm();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setIsSending(true);

    // Replace these with your actual EmailJS service details
    emailjs
      .sendForm(
        "service_l420l2n", // Replace with your service ID
        "template_i86dqpn", // Replace with your template ID
        formRef.current!,
        "kCRo_PVpsdNP1FPnP" // Replace with your public key
      )
      .then(() => {
        setFormData({
          name: "",
          email: "",
          mobile: "",
          subject: "",
        });
        setFloatingAlert({ 
          message: "Message sent successfully!",
          submessage:"We'll contact you soon.", 
          type: "success" 
        });
      })
      .catch(() => {
        setFloatingAlert({ 
          message: " Failed to send request.", 
          submessage :"Please try again.",
          type: "error" 
        });
      })
      .finally(() => setIsSending(false));
  };

  return (
   
    <div className="contant-background ">
      <h2 className="text-center mb-4">Contact us</h2>
       <div style={{borderRadius:"40px"}}>
      <Row className="contact-inner-background rounded p-4">
        {/* Left Section */}
        <Col md={6} className=" p-4">
          <h4 className="contact-get mb-3">Get in Touch With Our Team</h4>
          <p className="contact-para">
            At Xyloite Technologies, we transform businesses with smart,
            scalable solutions. Have a question or want to partner with us?
          </p>

          <div>
            {/* Email Section */}
            <div className="d-flex align-items-start mb-4">
              <div className="icon-circle me-3">
                <img src={mailIcon} alt="Email" className="icon-img" />
              </div>
              <div>
                <h6 className="fw-bold">Email Us</h6>
                <p className="mb-1 contact-details">Sales: hello@xyloite.com</p>
                <p className="contact-details">Career: hr@xyloite.com</p>
              </div>
            </div>

            {/* Phone Section */}
            <div className="d-flex align-items-start">
              <div className="icon-circle me-3">
                <img src={phoneIcon} alt="Phone" className="icon-img" />
              </div>
              <div>
                <h6 className="fw-bold">Phone</h6>
                <p className="mb-1 contact-details">Sales: +91 78128 07079</p>
                <p className="contact-details">Career: +91 9600910450</p>
              </div>
            </div>
          </div>
        </Col>

        {/* Right Section (Form) */}
        <Col md={6} className="ps-4 border-start right-border">
          <Form ref={formRef} onSubmit={handleSubmit} className="form-contact">
            <Form.Group className="mb-3 contact-input-title" controlId="formName">
              <Form.Label className="title-contact">Full Name</Form.Label>
              <Form.Control
                className="contact-place"
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter your Full name"
                isInvalid={!!errors.name}
              />
              <Form.Control.Feedback type="invalid">
                {errors.name}
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3 contact-input-title" controlId="formEmail">
              <Form.Label className="title-contact">Email Address</Form.Label>
              <Form.Control
                className="contact-place"
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your Email address"
                isInvalid={!!errors.email}
              />
              <Form.Control.Feedback type="invalid">
                {errors.email}
              </Form.Control.Feedback>
            </Form.Group>

<Form.Group className="mb-3 contact-input-title" controlId="formPhone">
  <Form.Label className="title-contact">Mobile Number</Form.Label>
  <PhoneInput
    name="mobile"
    international
    defaultCountry="IN"
    value={formData.mobile}
    onChange={(value) => {
      // Update value
      setFormData({ ...formData, mobile: value || "" });
      // Clear error if user types a new valid value
      setErrors((prev) => ({ ...prev, mobile: "" }));
    }}
    className={`form-control contact-place ${errors.mobile ? "is-invalid" : ""}`}
  />
  {errors.mobile && (
    <div className="invalid-feedback">{errors.mobile}</div>
  )}
</Form.Group>


            <Form.Group className="mb-3 contact-input-title" controlId="formSubject">
              <Form.Label className="title-contact">Subject</Form.Label>
              <Form.Control
                className="contact-place"
                type="text"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                placeholder="Enter your Subject"
                isInvalid={!!errors.subject}
              />
              <Form.Control.Feedback type="invalid">
                {errors.subject}
              </Form.Control.Feedback>
            </Form.Group>
<div style={{display:"flex",justifyContent:"space-around"}}>
            <Button 
              variant="success" 
              className="contact-submit-button" 
              type="submit"
              disabled={isSending}
            >
              {isSending ? "Sending..." : "Send a Message"}
            </Button>
            </div>
          </Form>
        </Col>
      </Row>
       </div>

      {/* Floating Alert */}
      {floatingAlert && (
        <FloatingAlert
          message={floatingAlert.message}
          submessage={floatingAlert.submessage}
          type={floatingAlert.type}
          duration={2000}
          onClose={() => setFloatingAlert(null)}
        />
      )}
    </div>
   
  );
};

export default ContactUs;